import React, { useState, useEffect } from 'react';
import {
    Route,
    Routes,
} from "react-router-dom";
import './App.css';

/* Pages */
import Home from "./pages/Home/HomePage";
import About from "./pages/About/AboutPage";
import Project from "./pages/Project/ProjectPage";
import ProjectVideos from "./pages/ProjectVideos/ProjectVideos"; // Import the new component

import RouterScrollTop from "./components/ScrollToTop/RouterScrollTop";

// Import skill logos
import htmlLogo from './assets/skills/html.png';
import cssLogo from './assets/skills/css.png';
import jsLogo from './assets/skills/javascript.png';
import reactLogo from './assets/skills/react.png';
import nodeLogo from './assets/skills/nodejs.png';
import pythonLogo from './assets/skills/python.png';
import djangoLogo from './assets/skills/django.png';
import mongodbLogo from './assets/skills/mongodb.png';
import nextjsLogo from './assets/skills/nextjs.png';
import fastapiLogo from './assets/skills/fastapi.png';

function App() {
    const [loading, setLoading] = useState(true);
    const [progress, setProgress] = useState(0);

    const skills = [
        { name: 'HTML', logo: htmlLogo, link: 'https://developer.mozilla.org/en-US/docs/Web/HTML' },
        { name: 'CSS', logo: cssLogo, link: 'https://developer.mozilla.org/en-US/docs/Web/CSS' },
        { name: 'JavaScript', logo: jsLogo, link: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript' },
        { name: 'React', logo: reactLogo, link: 'https://reactjs.org/' },
        { name: 'Node.js', logo: nodeLogo, link: 'https://nodejs.org/' },
        { name: 'Python', logo: pythonLogo, link: 'https://www.python.org/' },
        { name: 'Django', logo: djangoLogo, link: 'https://www.djangoproject.com/' },
        { name: 'MongoDB', logo: mongodbLogo, link: 'https://www.mongodb.com/' },
        { name: 'Next.js', logo: nextjsLogo, link: 'https://nextjs.org/' },
        { name: 'FastAPI', logo: fastapiLogo, link: 'https://fastapi.tiangolo.com/' },
    ];

    useEffect(() => {
        let loadedCount = 0;
        const total = skills.length;
        
        skills.forEach(skill => {
            const img = new Image();
            img.src = skill.logo;
            img.onload = img.onerror = () => {
                loadedCount++;
                setProgress(Math.round((loadedCount / total) * 100));
                if (loadedCount === total) {
                    setTimeout(() => {
                        setLoading(false);
                    }, 500); // slight delay to show 100%
                }
            };
        });
    }, []);

    return (
        <>
            <RouterScrollTop />
            {
                loading ?
                    <SkillLoader progress={progress} skills={skills} />
                    :
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/project" element={<Project />} />
                        <Route path="/project-videos" element={<ProjectVideos />} /> {/* Add this line */}
                    </Routes>
            }
        </>
    );
}

const SkillLoader = ({ progress, skills }) => {
    return (
        <div className='skill-loader'>
            <div className="skill-background">
                {skills.map((skill, index) => (
                    <a
                        key={index}
                        href={skill.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="floating-skill"
                        style={{
                            top: `${10 + (Math.random() * 80)}%`,
                            left: `${10 + (Math.random() * 80)}%`,
                            animationDelay: `${index * 0.5}s`,
                            animationDuration: `${15 + (Math.random() * 10)}s`
                        }}
                    >
                        <img src={skill.logo} alt={skill.name} />
                        <span>{skill.name}</span>
                    </a>
                ))}
            </div>

            <div className="loader-content">
                <h1 className="loader-title">Arun Singh</h1>
                <p className="loader-subtitle">Full Stack Developer</p>

                <div className="modern-spinner">
                    <div className="spinner-ring"></div>
                    <div className="spinner-ring"></div>
                    <div className="spinner-ring"></div>
                    <div className="spinner-core"></div>
                </div>

                <div className="loading-progress">
                    <div className="progress-text">Loading Portfolio</div>
                    <div className="progress-bar">
                        <div className="progress-fill" style={{ width: `${progress}%` }}></div>
                    </div>
                    <div className="progress-percentage">{progress}%</div>
                </div>

                <div className="loader-tip">
                    <span>Tip: </span>
                    <span className="tip-text">My favorite framework is React.js</span>
                </div>
            </div>
        </div>
    );
};

export default App;